export const BUILDVERSION = "2022-05-10,12:13:17"; // This line was autocreated by the batch script "C:\Users\darre\Dropbox\Sh\O2A Orbita-2 Outer\!O2A Build (incl VERSION) & deploy HOSTING .cmd"  at the time of the last build, and is used for the auto-updating feature.



// WEBPACK FOOTER //
// ./src/components/from_st_elsewhere/BuildVersion.js